import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import '../styles/merchant-banner.less';

export default class MerchantBanner extends React.Component {
  static propTypes = {
    merchantName: PropTypes.string,
    location: PropTypes.string,
    nodeId: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.string),
    authenticated: PropTypes.bool,
    isZapCashAccepted: PropTypes.bool,
    hasRedeemableReward: PropTypes.bool,
    branchCount: PropTypes.number,
    parent: PropTypes.bool,
    rankImage: PropTypes.string,
    openingHours: PropTypes.string,
    telephone: PropTypes.string,
    logo: PropTypes.string,
    address: PropTypes.string,
    cashBack: PropTypes.number,
    isZapCashAwarded: PropTypes.bool,
    spiel: PropTypes.string
  };

  toUrlFormat(str) {
    return str.replace(/\W+/g, '-').toLowerCase();
  }

  render() {
    let merchantNameUrl = this.toUrlFormat(this.props.merchantName);
    let branchNameUrl = this.toUrlFormat(this.props.location);
    let merchantUrl = `/merchants/${merchantNameUrl}/${branchNameUrl}/${
      this.props.nodeId
    }`;

    let bannerClasses = classNames('merchant-banner', this.props.categories, {
      authenticated: this.props.authenticated
    });

    let isZapCashAcceptedClasses = classNames({
      'zap-cash badge': this.props.isZapCashAccepted
    });

    let hasRedeemableRewardClasses = classNames({
      'reward badge': this.props.hasRedeemableReward
    });

    let branchesClasses = classNames('branches', {
      hidden: this.props.branchCount === 1 || !this.props.parent
    });

    let addressClasses = classNames('address', { full: !this.props.parent });

    let rankImage = this.props.rankImage ? (
      <img className="rank" src={this.props.rankImage} />
    ) : (
      <div />
    );

    let hasSpiel = this.props.spiel !== null;
    let details = hasSpiel ? (
      <div className="spiel">{this.props.spiel}</div>
    ) : (
      <div className="cashBack">
        <b>{this.props.cashBack}%</b>{' '}
        {this.props.isZapCashAwarded ? 'ZAPCASH' : 'STORE POINTS'}
      </div>
    );

    let openingHoursField;
    let telephoneNumberField;
    if (!this.props.parent) {
      openingHoursField = (
        <div className="opening-hours">{this.props.openingHours}</div>
      );
      telephoneNumberField = (
        <div className="telephone">{this.props.telephone} </div>
      );
    }

    return (
      <Link to={merchantUrl} className={bannerClasses}>
        <div className="merchant">
          <div className="filler" />
          <img className="logo" src={this.props.logo} />
          <div className="info">
            <div className="name">{this.props.merchantName}</div>
            <div className="location">{this.props.location}</div>
            {openingHoursField}
            <div className={addressClasses}>{this.props.address}</div>
            {telephoneNumberField}
          </div>
        </div>

        <div className="details">
          {details}

          <div className="badges">
            <div className={isZapCashAcceptedClasses} />
            <div className={hasRedeemableRewardClasses} />
            {rankImage}
          </div>

          <div className={branchesClasses}>
            {this.props.branchCount} branches
          </div>
        </div>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/widgets/MerchantBanner.js